import {useTranslation} from "react-i18next";
import {Button, Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider, useDataGrid} from "../../core/components/data-grid/DataGridContext";
import AutoExportRuleGrid from "../../app/auto-export/auto-export-rule-data-grid/AutoExportRuleGrid";
import Flex from "../../core/components/Flex";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import {useModal} from "../../core/context/ModalContext";
import AutoExportRuleCreateEdit from "../../app/auto-export/AutoExportRuleCreateEdit";

export default function AutoExportRuleGridPage() {
    const {t} = useTranslation();

    useEffect(() => {
        document.title = `${t('Auto Export Rules')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider>
                <AutoExportRuleGridContent />
            </DataGridProvider>
        </>
    )
}

function AutoExportRuleGridContent() {
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal();
    const {refreshDataGrid} = useDataGrid();

    const handleNewRule = () => {
        openModal(t('New Auto Export Rule'), (
            <AutoExportRuleCreateEdit
                onSaved={() => {
                    closeModal();
                    refreshDataGrid();
                }}
            />
        ), null, 1200);
    }

    const Title = () => {
        return (
            <Flex justifyContent={'space-between'}>
                <CardTitle title={t('Auto Export Rules')} />
                <Button onClick={handleNewRule}>
                    {t('New Rule')}
                </Button>
            </Flex>
        )
    }

    return (
        <LayoutWithSider
            fullWidth={true}
            showSidebar={false}
        >
            <Card title={<Title />}>
                <AutoExportRuleGrid />
            </Card>
        </LayoutWithSider>
    )
}
